module.exports = __webpack_public_path__ + "static/apk/eruul.f7a5186.apk";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=static/apk/[name].[hash:7].[ext]!./src/assets/apk/eruul.apk
// module id = Nnhn
// module chunks = 2